import React from 'react';
import { Outlet } from 'react-router-dom';

const ClientRouter = () => {
  return <Outlet />
}

export default ClientRouter;
